import { Box } from "@mui/material";
import styled from "styled-components";

export const FiltersContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingInline: "36px",
  borderBottom: "1px solid lightGray",
  padding: "24px 36px",
  backgroundColor: "white"
}));